import {
  Box,
  VStack,
  Heading,
  Text,
  HStack,
  Icon,
  SimpleGrid,
  Card,
  CardHeader,
  CardBody,
  Divider,
  useColorModeValue,
  Image
} from '@chakra-ui/react';
import { FaDonate, FaHandHoldingUsd, FaChurch } from 'react-icons/fa';
import { motion } from 'framer-motion';
import Logo from '../media/logo_transparent.png';

const Donations = () => {
  const bgColor = useColorModeValue('gray.50', 'gray.900');
  const cardBg = useColorModeValue('white', 'gray.800');
  const textColor = useColorModeValue('gray.700', 'gray.200');
  const purpleColor = useColorModeValue('purple.600', 'purple.300');
  const orangeColor = useColorModeValue('orange.500', 'orange.300');
  
  const donationMethods = [
    {
      title: "Bank Transfer",
      icon: FaDonate,
      details: [
        "Account Name: Alpha Youth UK",
        "Sort Code: 40-12-34",
        "Account Number: 12345678",
        "Reference: DONATION"
      ]
    },
    {
      title: "Online Giving",
      icon: FaHandHoldingUsd,
      details: [
        "Coming Soon!",
        "We're setting up secure online donation options",
        "Check back later or contact us for alternatives"
      ]
    },
    {
      title: "In-Person",
      icon: FaChurch,
      details: [
        "Cash/Cheque donations accepted at events",
        "Make cheques payable to 'Alpha Youth UK'",
        "Receipts available upon request"
      ]
    }
  ];

  return (
    <Box minH="100vh" bg={bgColor} mt={10} py={10} px={{ base: 4, md: 8 }}>
      <VStack spacing={10} maxW="1200px" mx="auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <VStack textAlign="center" spacing={4}>
            <Heading
              fontSize={{ base: "3xl", md: "4xl", lg: "5xl" }}
              fontWeight="extrabold"
              bgGradient={`linear(to-r, ${purpleColor}, ${orangeColor})`}
              bgClip="text"
            >
              Support Our Mission
            </Heading>
            <Text fontSize="xl" color={textColor} maxW="800px">
              Your generous donations help us reach more young people with the Gospel and provide life-changing programs.
            </Text>
          </VStack>
        </motion.div>

        <SimpleGrid columns={{ base: 1, md: 3 }} spacing={8} w="full">
          {donationMethods.map((method, index) => (
            <motion.div
              key={index}
              whileHover={{ y: -5 }}
              transition={{ duration: 0.3 }}
            >
              <Card bg={cardBg} boxShadow="lg" borderRadius="xl" h="100%">
                <CardHeader>
                  <HStack spacing={3}>
                    <Icon as={method.icon} boxSize={6} color={purpleColor} />
                    <Heading size="md">{method.title}</Heading>
                  </HStack>
                </CardHeader>
                <Divider borderColor={orangeColor} opacity="0.5" />
                <CardBody>
                  <VStack spacing={3} align="start">
                    {method.details.map((detail, i) => (
                      <HStack key={i} spacing={2} align="flex-start">
                        <Box color={orangeColor} fontSize="sm">•</Box>
                        <Text color={textColor}>{detail}</Text>
                      </HStack>
                    ))}
                  </VStack>
                </CardBody>
              </Card>
            </motion.div>
          ))}
        </SimpleGrid>

        <Box
          bgGradient={`linear(to-r, ${purpleColor}, ${orangeColor})`}
          p={8}
          borderRadius="xl"
          w="full"
          color="white"
          textAlign="center"
          boxShadow="xl"
        >
          <VStack spacing={4}>
            <Image src={Logo} alt="Alpha Youth UK" boxSize="100px" opacity="0.9" />
            <Heading size="lg">Thank You for Your Support!</Heading>
            <Text fontSize="lg">
              "Each of you should give what you have decided in your heart to give, not reluctantly or under compulsion, for God loves a cheerful giver." - 2 Corinthians 9:7
            </Text>
          </VStack>
        </Box>
      </VStack>
    </Box>
  );
};

export default Donations;